<template>
  <div class="bg-white p-2 my-4">
    <el-row :gutter="20" type="flex" class="row-bg" justify="center">
      <!-- Location -->
      <el-col :span="4" class="text-center" style="padding: 0 15px">
        <p class="input-label text-left title">Select Location</p>
        <el-select
          v-model="selectedOutlet"
          filterable
          sortable
          size="small"
          style="width: 100%"
          placeholder="Select Location"
          name="Select Store"
          class="capitalize"
          @change="changedSelectedOutlet"
        >
          <el-option :value="null" label="All"></el-option>
          <el-option v-for="(item, index) in outletLists" :key="index" :value="item.id" :label="item.name"
            class="capitalize">
          </el-option>
        </el-select>
      </el-col>
      <!-- ./Location -->
      <!-- Custom time range -->
      <el-col :span="4" class="text-center" style="padding: 0 15px">
        <p class="input-label text-left title">Report</p>
        <el-select
          v-model="selectedViewType"
          style="width: 100%"
          placeholder="Select"
          size="small"
          @change="changedDateTypeView"
        >
          <el-option
            v-for="(item, index) in calendarTypeList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <!-- ./Custom time range -->
      <!-- From -->
      <el-col :span="4" class="text-center" style="padding: 0 15px">
        <p class="input-label text-left title">From</p>
        <el-date-picker
          v-model="selectedFromDate"
          type="date"
          value-format="yyyy-MM-dd"
          size="small"
          style="width: 100%"
          placeholder="Pick a day"
          name="task_from_date"
          :disabled="selectedViewType != 'customDt'"
          :picker-options="{
            disabledDate: disabledDueDate,
            firstDayOfWeek: 1,
          }"
          @change="changedFromDate"
        ></el-date-picker>
      </el-col>
      <!-- ./From -->
      <!-- To -->
      <el-col :span="4" class="text-center" style="padding: 0 15px">
        <p class="input-label text-left title">To</p>
        <el-date-picker
          v-model="selectedToDate"
          value-format="yyyy-MM-dd"
          type="date"
          size="small"
          style="width: 100%"
          placeholder="Pick a day"
          name="task_to_date"
          :disabled="selectedViewType != 'customDt'"
          :picker-options="{
            disabledDate: disabledTaskReportToDate,
            firstDayOfWeek: 1,
          }"
          @change=changedToDate
        ></el-date-picker>
      </el-col>
      <!-- ./To -->
      <!-- View -->
      <el-col :span="4" class="text-center" style="padding: 0 15px">
        <p class="input-label text-left title">View</p>
        <el-select
          v-if="dashboardTab == 'audit'"
          v-model="selected_intermediate_category"
          style="width: 100%"
          placeholder="Audit Type"
          size="small"
          filterable
          @change="changeSelectAuditType"
        >
          <el-option
            v-for="(item, index) in auditIntermediateCategories"
            :key="'audit-type-' + index"
            :value="item.id"
            :label="item.name"
          ></el-option>
          <el-option v-if="selectedOutlet" value="overall_missing_logs" label="Missing logs"></el-option>
        </el-select>
        <el-select
          v-if="dashboardTab == 'other'"
          v-model="selected_intermediate_category"
          style="width: 100%"
          placeholder="Task Type"
          size="small"
          filterable
          @change="changeSelectAuditType"
        >
          <el-option
            v-for="(item, index) in taskIntermediateCategories"
            :key="'task-type-' + index"
            :value="item.id"
            :label="item.name"
          ></el-option>
          <template v-if="selectedOutlet">
            <el-option value="overall_missing_logs" label="Missing logs - Overall"></el-option>
            <el-option value="equipments_and_products_missing_logs" label="REV Missing Logs"></el-option>
          </template>
        </el-select>
      </el-col>
      <!-- ./View -->
    </el-row>
  </div>
</template>

<script>
export default {
  name: "TaskDashboardFilter",
  props: {
    outletLists: {
      required: true,
      type: Array,
    },
    calendarTypeList: {
      required: true,
      type: Array
    },
    taskIntermediateCategories: {
      required: true,
      type: Array,
    },
    auditIntermediateCategories: {
      required: true,
      type: Array
    },
    dashboardTab: {
      type: String,
      required: true
    },
    initialFromDate: {
      type: String,
      required: true
    },
    initialToDate: {
      type: String,
      required: true,
    },
    selectedType: {
      type: String,
      required: true,
    },
    selectedIntermediateCategory: {
      type: String,
      default: null
    },
    selectOutlet: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedOutlet: null,
      selectedViewType: "",
      selectedFromDate: "",
      selectedToDate: "",
      selected_intermediate_category: "",
      currentDashboardTab: "",
    };
  },
  watch: {
    initialFromDate(newValue, oldValue) {
      this.selectedFromDate = newValue;
    },
    initialToDate(newValue, oldValue) {
      this.selectedToDate = newValue;
    },
    selectedIntermediateCategory(newValue, oldValue) {
      this.selected_intermediate_category = newValue;
    },
    selectOutlet(newValue, oldValue) {
      this.selectedOutlet = newValue;
    },
    selectedType(newValue, oldValue) {
      this.selectedViewType = newValue;
    },
  },
  mounted() {
    this.selectedFromDate = this.initialFromDate;
    this.selectedToDate = this.initialToDate;
    this.selectedViewType = this.selectedType;
    this.selected_intermediate_category = this.selectedIntermediateCategory;
    this.selectedOutlet = this.selectOutlet;
  },
  methods: {
    changedSelectedOutlet(event) {
      this.$emit('changedSelectedOutlet', event);
    },
    changedDateTypeView(event) {
      this.$emit('changedDateTypeViewList', event);
    },
    changedFromDate(event) {
      this.$emit('changedFromDate', event);
    },
    changedToDate(event) {
      this.$emit('changedToDate', event)
    },
    changeSelectAuditType(event) {
      this.$emit('changedSelectedAuditType', event);
    },
    disabledTaskReportToDate(time) {
      let fromDate = new Date(this.selectedFromDate);
			return time.getTime() >= fromDate.getTime() && time.getTime() > Date.now();
    },
    disabledDueDate(time) {
			return time.getTime() > Date.now();
    },
  }
}
</script>